import { render, staticRenderFns } from "./ReplaceDialog.vue?vue&type=template&id=56e1bf98&"
import script from "./ReplaceDialog.vue?vue&type=script&lang=js&"
export * from "./ReplaceDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports